import { render } from "./DeliveryConfirm.vue?vue&type=template&id=d0ed73a6&scoped=true"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"

import "./DeliveryConfirm.vue?vue&type=style&index=0&id=d0ed73a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0ed73a6"

export default script